
const nonSpecial = "abcdefghijklmnopqrstuvwxyz0123456789";


export function stringToTrigrams(str) {
  return str.toLowerCase().split("").filter(c => nonSpecial.includes(c)).reduce((trigrams, _, i, arr) => {
    if (i < arr.length - 2) {
      trigrams.add(arr[i] + arr[i + 1] + arr[i + 2]);
    }
    return trigrams;
  }, new Set());
}

export function levenshtein(a, b) {
  const matrix = [];
  
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }
  
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1)
        );
      }
    }
  }
  
  return matrix[b.length][a.length];
}

